import http from '@/environment/environment';
import { Game, GameFeedback, GameList, PublishedGameDetail, GameRating} from '@/_models/Game';
import store from '@/store/index';
import { Helper } from "@/utils/Helper";

export interface fetchAuthKey{
    status: number;
    success: boolean;
    key: string;
}

export class GameService
{
    async getPublishedGame(gameId: string): Promise<Game> {
        try{
            const fetchGame = await http.get(`games/${gameId}/publish`);
            return fetchGame.data;
        }catch(err){
            Helper.endpointErrorHandling(err);
        }
    }

    async getAllPublishedGames(): Promise<PublishedGameDetail[]> {
        const fetchGames = await http.get(`games/published`);
        return fetchGames.data;
    }

    async getGenreCount(): Promise<any> {
        const fetchGenre = await http.get(`games/genre/count`);
        return fetchGenre.data;
    }

    async getGenrePublishedGames(category: string): Promise<PublishedGameDetail[]> {
        const fetchGames = await http.get(`games/published?genre=${category}&skip=0&limit=0`);
        return fetchGames.data;
    }

    async getDeveloperPublishedGames(developerID: string): Promise<PublishedGameDetail[]> {
        const fetchGames = await http.get(`games/published/dev?username=${developerID}`);
        return fetchGames.data;

    }

    async getDeveloperPopularityCount(developerID: string): Promise<PublishedGameDetail[]> {
        const fetchGames = await http.get(`games/popularity/count?username=${developerID}`);
        return fetchGames.data;

    }
    async getDeveloperFavouritesCount(developerID: string): Promise<PublishedGameDetail[]> {
        const fetchGames = await http.get(`games/favorited/count?username=${developerID}`);
        return fetchGames.data;
    }

    async getFeaturedGames(): Promise<any> {
        const fetchGames = await http.get(`games/featured/list`);
        return fetchGames.data;
    }

    async getRatingList(gameId: string): Promise<any> {
        const ratingList = await http.get(`games/${gameId}/rating/list`);
        return ratingList.data;
    }

    async updateGameDetails(gameName: string, userId: string, jwtToken: string, data: any): Promise<any> {
        http.defaults.headers.common['Authorization'] = jwtToken;
        return http.patch(`games/${gameName}?userId=${userId}`, data);
    }

    async rateGame(gameId: string, rating: string):Promise<GameRating>{
        const userObj = store.getters['auth/user'];
        const jwtToken = store.getters['auth/jwtToken']
        http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
        let status:boolean;
        let rate: string;
        try{
            const fetchRating = await http.post(`games/${gameId}/rating?userId=${userObj.userId}&rating=${rating}`);
            if(fetchRating.status == 201){
                status = true;
                rate = fetchRating.data.rating;
            }
        }catch(err){
            Helper.endpointErrorHandling(err);
            rate = 'Unable to submit rating for this game';
            status = false;
        }
        return {
            ratingStatus: status,
            rate
        };
    }

    async feedbackGame(gameId: string, message?: string): Promise<GameFeedback>{
        const userObj = store.getters['auth/user'];
        const jwtToken = store.getters['auth/jwtToken']
        http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;

        let status:boolean;
        let msg: string;
        try{
            const formData = new FormData();
            formData.append("message", message);
            const fetchFeedback = await http.post(`games/${gameId}/feedbacks?userId=${userObj.userId}`, formData);
            if(fetchFeedback.status == 200){
                status = true;
                msg = fetchFeedback.data.message;
            }
        }catch(err){
            Helper.endpointErrorHandling(err);
            msg = 'Unable to submit feedback for this game';
            status = false;
        }
        return {
            feedbackStatus: status,
            msg
        };
    }

    async getFavouriteList(): Promise<any> {
        const userObj = store.getters['auth/user'];
        const jwtToken = store.getters['auth/jwtToken']
        http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
        const favouriteList = await http.get(`games/favorite/list?userId=${userObj.userId}`);
        return favouriteList.data;
    }

    async favouriteGame(gameId: string): Promise<any>{
        const userObj = store.getters['auth/user'];
        const jwtToken = store.getters['auth/jwtToken']
        http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
        try{
            const fetchFavourite = await http.post(`games/${gameId}/favorite?userId=${userObj.userId}`);
        }catch(err){
            Helper.endpointErrorHandling(err);
        }
    }

    async unfavouriteGame(gameId: string): Promise<any>{
        const userObj = store.getters['auth/user'];
        const jwtToken = store.getters['auth/jwtToken']
        http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
        try{
            const fetchUnfavourite = await http.delete(`games/${gameId}/unfavorite?userId=${userObj.userId}`);
        }catch(err){
            Helper.endpointErrorHandling(err);
        }
    }

    async getAccessTokenKey(gameId: string):Promise<fetchAuthKey>{
        const userObj = store.getters['auth/user'];
        const jwtToken = store.getters['auth/jwtToken']
        http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;

        try{
            const formData = new FormData();
            formData.append('pointerId', gameId);
            formData.append('hoursToExpire', '2');
            const fetchAccessToken = await http.post(`apikeys?userId=${userObj.userId}`, formData);
            // console.log(fetchAccessToken.data);
            // console.log(fetchAccessToken.status);
            if(fetchAccessToken.data.success && fetchAccessToken.status == 200){
                return {
                    key: fetchAccessToken.data.viewModel.key,
                    status: fetchAccessToken.status,
                    success: true
                }
            }else{
                return {
                    key: '',
                    status: fetchAccessToken.status,
                    success: false
                }
            }
        }catch(err){
            Helper.endpointErrorHandling(err);
            return {
                key: '',
                status: 0,
                success: false
            }
        }
    }
}

